// src/components/OAuthCallback.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store';
import { setUser } from '../../store/authSlice';
import { getCurrentUser } from '../../services/api';

const OAuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch<AppDispatch>();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Missing token');
      navigate('/login', { replace: true });
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        localStorage.setItem('authToken', token);
        const userData = await getCurrentUser();
        if (cancelled) return;
        if (userData && userData.email) {
          dispatch(setUser({ email: userData.email, role: userData.role, id: (userData as any).id }));
          navigate('/dashboard', { replace: true });
        } else {
          setError('Invalid user data');
          navigate('/login', { replace: true });
        }
      } catch (e) {
        if (!cancelled) {
          setError((e as Error).message || 'Failed to complete sign-in');
          navigate('/login', { replace: true });
        }
      }
    })();
    return () => { cancelled = true; };
  }, [searchParams, dispatch, navigate]);

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100">
        <p className="text-lg font-semibold text-red-600">{error}. Redirecting to login...</p>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <p className="text-lg font-semibold text-blue-600">Completing sign-in...</p>
    </div>
  );
};

export default OAuthCallback;
